import { styled } from "@mui/material/styles";

type LinkProps = { primary: string };

// ─── Page wrapper ──────────────────────────────────────────────────────────────

export const SidebarHeaderContainer = styled("div")`
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  width: 100%;
  background-color: #f5f5f5;
`;

// ─── Sidebar ───────────────────────────────────────────────────────────────────

export const Sidebar = styled("div")`
  display: flex;
  flex-direction: column;
  width: 245px;
  min-width: 245px;
  background-color: #00b6bc;
  position: sticky;
  top: 0;

  /* 100vh no celular inclui a área atrás da barra do navegador; o dvh mede o
     que está realmente visível. O vh fica antes como fallback. */
  height: 100vh;
  height: 100dvh;

  /* Quem rola é a lista de itens, não a barra inteira: com a barra rolando,
     o rodapé com o "Sair" ia para fora da área visível em qualquer tela mais
     baixa que o conteúdo (~683px), e ninguém adivinha que precisa arrastar
     dentro do menu para achá-lo. */
  overflow: hidden;
  flex-shrink: 0;
`;

export const SidebarMenu = styled("div")`
  display: flex;
  flex-direction: column;
  flex: 1;

  /* min-height: 0 é o que permite a um filho de flex encolher abaixo do
     próprio conteúdo. Sem ele o overflow-y nunca entra em ação. */
  min-height: 0;
  overflow-y: auto;
`;

// ─── Logo area ─────────────────────────────────────────────────────────────────

export const LogoArea = styled("div")`
  padding: 24px 20px 20px;
`;

export const LogoMenu = styled("img")`
  height: 36px;
  cursor: pointer;
  filter: brightness(0) invert(1);
`;

export const LogoDivider = styled("div")`
  height: 1px;
  background-color: rgba(255, 255, 255, 0.35);
  margin: 16px 20px 0;
`;

// ─── Menu items ────────────────────────────────────────────────────────────────

export const MenuContainer = styled("nav")`
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  flex: 1;
`;

export const MenuItemWrapper = styled("div")<{ active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px 20px;
  cursor: pointer;
  position: relative;
  transition: background 0.15s;
  background-color: ${({ active }) =>
    active ? "rgba(255,255,255,0.15)" : "transparent"};

  &:hover {
    background-color: rgba(255, 255, 255, 0.12);
  }

  /* Active indicator — white bar on right */
  &::after {
    content: "";
    display: ${({ active }) => (active ? "block" : "none")};
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 60%;
    border-radius: 3px 0 0 3px;
    background-color: #ffffff;
  }
`;

export const MenuItemLabel = styled("span")`
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
`;

export const MenuItemIcon = styled("span")`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  flex-shrink: 0;
  color: #ffffff;
  opacity: 0.9;
`;

// ─── Sidebar footer ────────────────────────────────────────────────────────────

export const SidebarFooter = styled("div")`
  /* nunca encolhe nem sai do fluxo: é o que mantém o "Sair" sempre no rodapé */
  flex-shrink: 0;
  padding: 20px 20px 28px;
  border-top: 1px solid rgba(255, 255, 255, 0.25);
`;

export const SidebarFooterLink = styled("div")`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 8px 0;

  &:hover span {
    opacity: 0.8;
  }
`;

export const CopyrightContainer = styled("div")`
  padding: 8px 20px 0;
`;

// ─── Main content area ─────────────────────────────────────────────────────────

export const HeaderContent = styled("div")`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const Header = styled("div")`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 14px;
  height: 70px;
  padding: 0 32px;
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
`;

export const ComponentContent = styled("div")`
  flex: 1;
  padding: 28px 28px;
  min-width: 0;
`;

// ─── Misc (kept for compat) ────────────────────────────────────────────────────

export const HideItemDesk = styled("div")`
  display: flex;
  align-items: center;
`;

export const LinkA = styled("a")<LinkProps>`
  text-decoration: none;
  color: ${(p) => p.primary};
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const ImgSgv = styled("img")``;

// Legacy — kept so other pages that import these don't break
export const MenuContainerSection   = styled("div")``;
export const MenuContainerHeader    = styled("div")``;
export const MenuLinearGradienteDow = styled("div")``;
export const MenuTituloDiv          = styled("div")``;
export const LoginFFH3              = styled("span")``;
export const LoginB6H3              = styled("span")``;
export const AvatarContainer        = styled("img")``;